import Service from "@ember/service";
import type Chart from "chart.js";

export default class ChartJSService extends Service {
  registered = false;

  async register(): Promise<typeof Chart.Chart> {
    return import("chart.js").then(
      ({
        Chart,
        LinearScale,
        LineController,
        LineElement,
        PointElement,
        TimeScale,
        Legend,
        Tooltip,
        Filler
      }) => {
        return import("chartjs-adapter-dayjs-3").then(() => {
          if (this.registered) return Chart;

          Chart.register(
            LineController,
            LinearScale,
            TimeScale,
            PointElement,
            LineElement,
            Legend,
            Tooltip,
            Filler
          );

          this.registered = true;
          return Chart;
        });
      }
    );
  }
}

declare module "ember__service" {
  interface Registry {
    chartjs: ChartJSService;
  }
}
